<template>
  <div
    v-if="pageParents.length > 0 && !isMobile"
    class="breadcrumb-page-parents"
  >
    <div
      v-if="hasPageMoreParents"
      v-click-outside="hideParentPageDropdown"
      class="breadcrumb-item"
      @click.stop="toogleParentPageDropdown"
    >
      <span class="breadcrumb-item-text page-parents">...</span>
      <div
        v-if="parentPageDropdown"
        class="dropdown page-parents-dropdown"
      >
        <a
          v-for="(pageId, index) in restOfPageParents"
          :key="index"
          :href="getPageLink(pageId)"
          class="page-parent-item pt no-underline"
          @click.stop="openParentPage(pageId, $event)"
        >
          <em
            v-if="index !== 0"
            class="custom-icons bg-icon-default"
            :style="[getCustomIconStyle(iconPath('corner-down-right')), { background: '#98A2B3' }]"
          />
          <ResourceIcon
            :src="getPageById(pageId).icon?.src || 'page'"
            :color="getPageById(pageId).icon?.color"
            :type="getPageById(pageId).icon?.type"
          />
          <span class="page-parent-title">
            {{ getPageById(pageId).title || translate('untitledPage') }}
          </span>
        </a>
      </div>
    </div>
    <span
      v-if="hasPageMoreParents"
      class="breadcrumb-separator"
      >/</span
    >
    <a
      v-if="pageImmediateParent"
      class="breadcrumb-item no-underline"
      :href="getPageLink(pageImmediateParent)"
      @click="openParentPage(pageImmediateParent, $event)"
    >
      <ResourceIcon
        :src="immediateParentPageObject.icon?.src || 'page'"
        :color="immediateParentPageObject.icon?.color"
        :type="immediateParentPageObject.icon?.type"
      />
      <span
        ref="pageImmediateParent"
        v-tooltip="{
          content: immediateParentPageObject.title || translate('pageTitlePlaceholder'),
          onShow: () => !parentPageTitleTooltip,
          placement: 'bottom',
        }"
        class="breadcrumb-item-text transparent-border"
      >
        {{ immediateParentPageObject.title || translate('pageTitlePlaceholder') }}
      </span>
    </a>
    <span
      v-if="pageImmediateParent"
      class="breadcrumb-separator"
    >
      /
    </span>
  </div>
</template>

<script>
import getDashedTitle from '@/utilities/getDashedTitle';
import customIconsMixin from '@/mixins/customIconsMixin';
import breadcrumbTooltipMixin from '@/mixins/breadcrumbTooltipMixin';
import ResourceIcon from '@/components/elements/common/ResourceIcon';
import { cmdClickOpenInNewTab } from '@/utilities/openInNewTab';

export default {
  name: 'BreadcrumbPageParents',

  components: { ResourceIcon },

  mixins: [customIconsMixin, breadcrumbTooltipMixin],

  data() {
    return {
      parentPageDropdown: false,
    };
  },

  computed: {
    pageParents() {
      return (
        this.getPageParents(this.page.id || this.sidebarDraftPage.id) || [].slice().reverse() || []
      );
    },

    pageImmediateParent() {
      return this.pageParents[0] || null;
    },

    restOfPageParents() {
      return this.pageParents.slice(1).reverse() || [];
    },

    hasPageMoreParents() {
      return this.restOfPageParents.length > 0;
    },

    teamSlug() {
      return this.$store.getters.getTeamSlug;
    },

    page() {
      return this.$store.getters.getPage;
    },

    currentPageId() {
      return this.$store.getters.getCurrentPageID;
    },

    sidebarDraftPage() {
      return this.$store.getters.sidebarDraftPage;
    },

    pageArchived() {
      return this.page?.archived?.time_archived != null;
    },

    immediateParentPageObject() {
      return this.getPageById(this.pageImmediateParent);
    },
  },

  methods: {
    getPageParents(pageId) {
      const parents = [];
      const pageTree = this.pageArchived
        ? this.$store.getters.getProjectPagesArchiveTree(this.page.project_id)
        : this.$store.getters.getProjectPagesTree(
            this.page.project_id || this.sidebarDraftPage.projectId
          );
      let page = pageTree[pageId];

      while (page && page.parent !== 'root') {
        parents.push(page.parent);
        page = pageTree[page.parent];
      }

      return parents;
    },

    getPageLink(pageId) {
      const page = this.getPageById(pageId);
      const baseRoute = `/${this.teamSlug}/page-${page.id}`;
      let route = baseRoute;
      if (page.title) {
        const dashedTitle = getDashedTitle(page.title);
        route = `${baseRoute}-${dashedTitle}`;
      }

      return route;
    },

    openParentPage(pageId, e) {
      e.preventDefault();
      const route = this.getPageLink(pageId);

      if (this.$route.path === route) return;
      if (cmdClickOpenInNewTab(route, e)) {
        this.hideParentPageDropdown();
        return;
      }

      const page = this.getPageById(pageId);
      this.$store.dispatch('setPage', page);
      this.$store.dispatch('setNewPageCreating', false);
      this.$store.dispatch('setCurrentPageID', pageId);

      this.$router.push(route);
      this.hideParentPageDropdown();
    },

    toogleParentPageDropdown() {
      this.parentPageDropdown = !this.parentPageDropdown;
    },

    hideParentPageDropdown() {
      this.parentPageDropdown = false;
    },

    getPageById(pageId) {
      return this.$store.getters.getPageById(pageId) || {};
    },
  },
};
</script>
